import api from "../lib/apiClient";

// §16 Face Verification
export const getFaceSettings = (params = {}) =>
  api.get("/face/settings", { params }).then(r => r.data);

export const getAllFaceSettings = (params = {}) =>
  api.get("/face/settings/all", { params }).then(r => r.data);

export const updateFaceSettings = (payload) =>
  api.put("/face/settings", payload).then(r => r.data);

export const updateBranchFaceSettings = (branchId, payload) =>
  api.put(`/branches/${branchId}/face/settings`, payload).then(r => r.data);

export const listEnrollments = (params = {}) =>
  api.get("/face/enrollments", { params }).then(r => r.data);

export const getEnrollment = (employeeId) =>
  api.get(`/face/enrollments/${employeeId}`).then(r => r.data);

export const uploadEnrollmentPhoto = (employeeId, formData) =>
  api.post(`/face/enrollments/${employeeId}/photo`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then(r => r.data);

export const submitEnrollment = (employeeId, payload) =>
  api.post(`/face/enrollments/${employeeId}`, payload).then(r => r.data);

export const deleteEnrollment = (employeeId, payload = {}) =>
  api.delete(`/face/enrollments/${employeeId}`, { data: payload }).then(r => r.data);

export const listVerifications = (params = {}) =>
  api.get("/face/verifications", { params }).then(r => r.data);

export const getVerificationsSummary = (params = {}) =>
  api.get("/face/verifications/summary", { params }).then(r => r.data);

export const getVerification = (id) =>
  api.get(`/face/verifications/${id}`).then(r => r.data);

export const reviewVerification = (id, payload) =>
  api.post(`/face/verifications/${id}/review`, payload).then(r => r.data);
